export enum NewActionsEnum {
  NEWS_INIT_PAGE = 'NEWS_INIT_PAGE',
  NEWS_GET_DATA = 'NEWS_GET_DATA',
  NEWS_SET_DATA = 'NEWS_SET_DATA',
  NEWS_SET_FILTER_OPTION = 'NEWS_SET_FILTER_OPTION',
  NEWS_GET_ROLES_OPTION = 'NEWS_GET_ROLES_OPTION',
  NEWS_SET_ROLES_OPTION = 'NEWS_SET_ROLES_OPTION',
  NEWS_GET_ANNOUNCE = 'NEWS_GET_ANNOUNCE',
  NEWS_SET_ANNOUNCE = 'NEWS_SET_ANNOUNCE',
  NEWS_GET_ATTACHMENT_NEWS = 'NEWS_GET_ATTACHMENT_NEWS',
}
